import * as React from "react";
import { isRedirect } from "@tanstack/router-core";
import { useRouter } from "@tanstack/react-router";
function useServerFn(serverFn) {
  const router = useRouter();
  return React.useCallback(
    async (...args) => {
      try {
        const res = await serverFn(...args);
        if (isRedirect(res)) {
          throw res;
        }
        return res;
      } catch (err) {
        if (isRedirect(err)) {
          err.options._fromLocation = router.state.location;
          return router.navigate(router.resolveRedirect(err).options);
        }
        throw err;
      }
    },
    [router, serverFn]
  );
}
export {
  useServerFn
};
//# sourceMappingURL=useServerFn.js.map
